import { useMemo } from "react";

export default function useData(
  date,
  dateFormatted,
  dateHuman,
  seats,
  node,
  code,
  codePrice,
  price,
  thankyou
) {
  return useMemo(() => {
    const _node = { ...node };

    if (date) {
      _node.date = date;
    }

    if (dateFormatted) {
      _node.bookingDateFormatted = dateFormatted;
    }

    if (dateHuman) {
      _node.bookingDateHuman = dateHuman;
    }

    if (seats) {
      _node.bookingSeats = seats;
    }

    if (code && code !== "0") {
      _node.hasBookingCoupon = true;
    }

    if (codePrice) {
      _node.couponPrice = codePrice;
    }

    if (price) {
      _node.bookingCost = price;
    }

    if (thankyou) {
      _node.bookingSuccessMessage = thankyou;
    }

    return _node;
  }, [
    date,
    dateFormatted,
    dateHuman,
    seats,
    node,
    code,
    codePrice,
    price,
    thankyou,
  ]);
}
